<div class="pm-overlay open" (click)="closed.emit()"></div>
<div class="pm open pin-change-dialog" (click)="$event.stopPropagation()">
  <div class="pm-header">
    <div class="pm-avatar" style="background: linear-gradient(135deg, #43a047, #2e7d32);">
      <i class="pi pi-lock" style="color: white; font-size: 1.5rem;"></i>
    </div>
    <h3 class="pm-name">{{ pinChangeMode() === 'setup' ? ('PIN.SETUP_TITLE' | translate) : ('PIN.CHANGE_PIN' | translate) }}</h3>
  </div>

  <div class="pm-body" style="display: flex; flex-direction: column; align-items: center; padding: 1.5rem;">
    <!-- Current PIN (change mode only) -->
    @if (pinChangeMode() === 'change' && pinChangeStep() === 'current') {
      <p class="pin-subtitle" style="margin-bottom: 1rem; color: #6b5b8e; font-size: 0.875rem;">{{ 'PIN.ENTER' | translate }}</p>
    }
    @if (pinChangeMode() === 'change' && pinChangeStep() === 'new') {
      <p class="pin-subtitle" style="margin-bottom: 1rem; color: #6b5b8e; font-size: 0.875rem;">{{ 'PIN.RESET_TITLE' | translate }}</p>
    }
    @if (pinChangeStep() === 'confirm') {
      <p class="pin-subtitle" style="margin-bottom: 1rem; color: #6b5b8e; font-size: 0.875rem;">{{ 'PIN.CONFIRM' | translate }}</p>
    }
    @if (pinChangeMode() === 'setup' && pinChangeStep() === 'new') {
      <p class="pin-subtitle" style="margin-bottom: 1rem; color: #6b5b8e; font-size: 0.875rem;">{{ 'PIN.SETUP_TITLE' | translate }}</p>
    }

    <!-- PIN dots -->
    <div class="pin-dots" style="display: flex; gap: 14px; margin-bottom: 1.25rem;">
      @for (dot of [0,1,2,3,4,5]; track dot) {
        <div style="width: 14px; height: 14px; border-radius: 50%; transition: all 0.2s;"
             [style.background]="dot < pinChangeDigits().length ? '#43a047' : '#e4ddef'"
             [style.transform]="dot < pinChangeDigits().length ? 'scale(1.15)' : 'scale(1)'"
             [style.box-shadow]="dot < pinChangeDigits().length ? '0 0 8px rgba(67,160,71,0.5)' : 'none'">
        </div>
      }
    </div>

    @if (pinChangeError()) {
      <p style="color: #e53935; font-size: 0.8125rem; margin: 0 0 0.75rem;">{{ pinChangeError() }}</p>
    }

    <!-- Number pad -->
    <div class="pin-pad" style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; width: 240px;">
      @for (n of ['1','2','3','4','5','6','7','8','9']; track n) {
        <button type="button" class="pin-key" style="height: 50px; border-radius: 12px; background: #f3f0fa; border: 1px solid #e4ddef; color: #1a0b3d; font-size: 1.25rem; cursor: pointer; font-family: inherit;" (click)="digitEntered.emit(n)">{{ n }}</button>
      }
      <div style="height: 50px;"></div>
      <button type="button" class="pin-key" style="height: 50px; border-radius: 12px; background: #f3f0fa; border: 1px solid #e4ddef; color: #1a0b3d; font-size: 1.25rem; cursor: pointer; font-family: inherit;" (click)="digitEntered.emit('0')">0</button>
      <button type="button" style="height: 50px; border-radius: 12px; background: transparent; border: none; color: #9b8bc4; cursor: pointer;" (click)="digitDeleted.emit()">
        <i class="pi pi-arrow-left"></i>
      </button>
    </div>
  </div>

  <div class="pm-divider"></div>
  <div class="pm-footer">
    <button class="pm-btn-cancel" (click)="closed.emit()">{{ 'COMMON.CANCEL' | translate }}</button>
  </div>
</div>
